import axios from "axios";
import { goldToast } from "gold-ui-kit";
import CONFIG from "../config";
import { store } from "../store";

const branchapi = axios.create({
  timeout: 10000,
  baseURL: CONFIG.branchApi,
});

branchapi.interceptors.request.use(
  (config) => {
    const token = store.getState()?.auth?.token;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

branchapi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { status, response } = error;
    let data = response?.data;

    switch (status) {
      case 400:
        goldToast.error(data?.ExceptionMessage || "Geçersiz istek.", { title: "Hata (400)" });
        break;
      case 401:
        if (!error.config?._skip401Handler) {
          window.dispatchEvent(new CustomEvent("auth-failed"));
        }
        break;
      default:
        break;
    }

    return Promise.reject(error);
  }
);

export default branchapi;
